import React from "react";
import { Typography, Spin } from "antd";

import "./StatsCard.css";

const StatsCard = (props) => {
  return (
    <div className="stats-card-container">
      <Typography className="stats-card-header">{props.title}</Typography>
      {props?.value || props?.value=== 0 ? (
        <div className="stats-card-data">{props.value}</div>
      ) : (
        <div className="report-stats-data center-loader">
          <Spin />
        </div>
      )}
      <div
        className="stats-card-action-caption"
        onClick={() => props.actionHandler()}
      >
        {props.actionIcon}
        <span className="stats-card-action-caption-margin">
          <Typography.Text
            strong
            style={{ color: "#2E546D", cursor: "pointer" }}
          >
            {props.actionCaption}
          </Typography.Text>
        </span>
      </div>
    </div>
  );
};

export default StatsCard;
